import { configureStore } from '@reduxjs/toolkit';
import navigationDrawerReducer from './reducers/navigationDrawerReducer';
import authReducer from './reducers/authReducer';
import appLayoutReducer from './reducers/appLayoutReducer';
import staticHandbooksReducer from './reducers/staticHandbooksReducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    navigationDrawer: navigationDrawerReducer,
    appLayout: appLayoutReducer,
    staticHandbooks: staticHandbooksReducer,
  },
});
